module.exports = __webpack_public_path__ + "img/sending.1d86c609.svg";